import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const strangerAnxietyWhen: BlogMetaData = {
  title: '人見知りはいつから？いつまで続く？激しい時の対応をモンテッソーリ視点で解説',
  description:
    '赤ちゃんの人見知りはいつから始まり、いつまで続く？激しい人見知りの原因と対応法を、モンテッソーリの敏感期の視点からやさしく解説。発達障害との違いや相談先も紹介します。',
  thumbnailUrl: '/img/blog-stranger-anxiety-when.webp',
  filePath: buildBlogFilePath('stranger-anxiety-when'),
  category: BLOG_CATEGORY.PARENTING,
};
